<template>
  <CContainer class="d-flex align-items-center justify-content-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="8">
        <div class="w-100">
          <div class="clearfix text-center">
            <div class="w-100">
              <img class="background-error" src="../../../public/img/error-404.png" alt="error-404">
            </div>
            <h4 class="pt-3">Oops! You're lost.</h4>
            <p class="text-muted">The page you are looking for was not found.</p>
          </div>
      </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: 'Page404'
}
</script>

<style scoped>
  .background-error {
    width: 100%;
    max-width: 100%;
  }
</style>